module.exports = __webpack_public_path__ + "images/93a91d1f2a9501d7109ff5bf8cc8aa23geology.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/geology.png
// module id = OED0
// module chunks = 0